import { isEmpty, isEqual, xorWith } from 'lodash';
// https://stackoverflow.com/a/57166363
export function isArrayEqual<T>(x: T[], y: T[]): boolean {
	return isEmpty(xorWith(x, y, isEqual));
}
